import React, {CSSProperties} from "react";
import checkIcon from "../../assets/svgs/check_complete.svg";
import classNames from "classnames";
import {HomeContentScrollClass} from "./variable/HomeContentType";

type ChildrenProps = {
    children: React.ReactNode,
    className?: string
}

export const MainHeading: React.FC<ChildrenProps> = ({children, className}) => {
    return (
        <div className={classNames("text-console-black text-[52px] font-bold leading-[130%] break-keep whitespace-pre-wrap", className ?? "")}>
            {children}
        </div>
    )
}

export const MainDescription: React.FC<ChildrenProps> = ({children, className}) => {
    return (
        <div className={classNames("text-console-black text-[18px] font-medium whitespace-pre-wrap", className ?? "")}>
            {children}
        </div>
    )
}

export const Heading: React.FC<ChildrenProps> = ({children, className}) => {
    return (
        <div className={classNames("text-console-black text-[24px] font-bold leading-[130%] whitespace-pre-wrap", className ?? "")}>
            {children}
        </div>
    )
}

export const Description: React.FC<ChildrenProps> = ({children, className}) => {
    return (
        <div className={classNames("text-console-black text-[16px] font-medium leading-[140%] whitespace-pre-wrap", className ?? "")}>
            {children}
        </div>
    )
}

export const Comment: React.FC<ChildrenProps> = ({children, className}) => {
    return (
        <div className={classNames("text-console-dark-gray text-[14px] font-normal leading-[140%] whitespace-pre-wrap", className ?? "")}>
            {children}
        </div>
    )
}

export const CheckList: React.FC<ChildrenProps> = ({children, className}) => {
    return (
        <div className={classNames("flex flex-col pl-[16px] gap-y-[12px] whitespace-pre-wrap", className ?? "")}>
            {children}
        </div>
    );
}

export const CheckListItem: React.FC<ChildrenProps> = ({children, className}) => {
    return (
        <div className={classNames("flex items-center gap-x-[8px]", className ?? "")}>
            <img src={checkIcon} alt="logo" width={16} height={16}/>
            <div className="text-console-black text-[14px] font-medium leading-[140%] whitespace-pre-wrap">{children}</div>
        </div>
    );
}

type HomeContentPageProps = {
    scrollId?: string
    className?: string
    bgStyle?: CSSProperties
    children: React.ReactNode
}

const HomeContentPage: React.FC<HomeContentPageProps> = (props) => {
    const {scrollId, children, className, bgStyle} = props;

    return (
        <div id={scrollId}
             className={classNames(HomeContentScrollClass, "lg:min-h-screen flex justify-center items-center overflow-x-clip")}
             style={bgStyle}>
            <div className={classNames("w-[1168px] mx-[40px] flex flex-col lg:flex-row justify-between items-center",
                "gap-y-[24px] gap-x-[24px]", className ?? "")}>
                {children}
            </div>
        </div>
    )
}

export default HomeContentPage
